import React from "react";


const LatestTransactions = () => {
    return(
        <div className="container">
            <div className="row">
                <p>Latest transactions here...</p>
            </div>
        </div>
    )
};


export default LatestTransactions;